import React from 'react';
import { HistoryRow } from '../driverHistoryTypes';
import styles from './HistoryTable.module.css';

interface HistoryTableProps {
  rows: HistoryRow[];
  onViewDetails?: (id: string) => void;
}

export const HistoryTable: React.FC<HistoryTableProps> = ({ rows, onViewDetails }) => {
  return (
    <div className={styles.card}>
      <h3 className={styles.title}>Deliveries</h3>
      <div className={styles.tableWrap}>
        <table className={styles.table}>
          <thead>
            <tr>
              <th>ROUTE ID</th>
              <th>DATE</th>
              <th>NUMBER OF STOPS</th>
              <th>TOTAL ORDERS</th>
              <th>STATUS</th>
              <th>ACTION</th>
            </tr>
          </thead>
          <tbody>
            {rows.map((row) => (
              <tr key={row.id}>
                <td className={styles.bold}>{row.routeId}</td>
                <td>{row.date}</td>
                <td>{row.numberOfStops}</td>
                <td>{row.totalOrders}</td>
                <td>
                  <span className={`${styles.status} ${styles[`status_${row.status.toLowerCase()}`]}`}>
                    {row.status}
                  </span>
                </td>
                <td>
                  <button className={styles.detailsBtn} onClick={() => onViewDetails?.(row.id)}>
                    View Details
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};
